exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 99
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20